module.exports = __webpack_public_path__ + "static/team-827101dbda35d3fdf02bc2730c7bf1af.jpg";